export var DummyRasterizer = function (_a) {
    var children = _a.children;
    return children;
};
//# sourceMappingURL=index.js.map